import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from "../Components/Sidebar";
import Login from "../Pages/Auth/Login";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("accessToken");
  
  // If no token exists, redirect to login
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return children;
};

const AllRoutes = () => {
  const token = localStorage.getItem("accessToken");
  
  return (
    <Routes>
      <Route path="/" element={token ? <Navigate to="/users-analytics" replace /> : <Login />} />
      
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Sidebar />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AllRoutes;